import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as C}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const s=t("save",C`
        <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M18.0556 2H4.72222C3.48889 2 2.5 3 2.5 4.22222V19.7778C2.5 21 3.48889 22 4.72222 22H20.2778C21.5 22 22.5 21 22.5 19.7778V6.44444L18.0556 2ZM20.2778 19.7778H4.72222V4.22222H17.1333L20.2778 7.36667V19.7778ZM12.5 12C10.6556 12 9.16667 13.4889 9.16667 15.3333C9.16667 17.1778 10.6556 18.6667 12.5 18.6667C14.3444 18.6667 15.8333 17.1778 15.8333 15.3333C15.8333 13.4889 14.3444 12 12.5 12ZM5.83333 5.33333H15.8333V9.77778H5.83333V5.33333Z"
                fill="#FCFCFC" />
        </svg>
    `),v=t("save_filled",C`
        <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M18.0556 2H4.72222C3.48889 2 2.5 3 2.5 4.22222V19.7778C2.5 21 3.48889 22 4.72222 22H20.2778C21.5 22 22.5 21 22.5 19.7778V6.44444L18.0556 2ZM12.5 19.7778C10.6556 19.7778 9.16667 18.2889 9.16667 16.4444C9.16667 14.6 10.6556 13.1111 12.5 13.1111C14.3444 13.1111 15.8333 14.6 15.8333 16.4444C15.8333 18.2889 14.3444 19.7778 12.5 19.7778ZM15.8333 8.66667H4.72222V4.22222H15.8333V8.66667Z"
                fill="#FCFCFC" />
        </svg>
    `);export{s as Save,v as SaveFilled};
